import angular from 'angular'
import './shinies.service'

angular
  .module('admin.shinie_redemption', ['admin.shinie_redemption.service'])
  .controller('ShiniesRedemptionCtrl', ShiniesRedemptionCtrl)

/** @ngInject */
function ShiniesRedemptionCtrl($scope, ShinieRedemptionService) {
  var vm = this
  vm.items = []
  vm.customDate = false
  vm.displayStartDate = moment().startOf('day').unix() + '000'
  vm.displayEndDate = moment().startOf('day').unix() + '000'
  vm.startDate = moment().startOf('day').unix() + '000000'
  vm.endDate = moment().endOf('day').unix() + '000000'
  vm.type = null
  vm.userId = null
  vm.date1 = null
  vm.date2 = null

  vm.types = [
    {
      id: 0,
      name: 'Standard',
    },
    {
      id: 1,
      name: 'Bounty',
    },
    {
      id: 2,
      name: 'Redeemable',
    },
    {
      id: 3,
      name: 'Raffle',
    },
  ]

  vm.openCalendar = function (e, type) {
    e.preventDefault()
    e.stopPropagation()

    if (type === 1) {
      vm.isOpen = true
      vm.isOpen1 = false
    } else if (type === 2) {
      vm.isOpen = false
      vm.isOpen1 = true
    }
  }

  vm.filterDate = function (key) {
    vm.customDate = false
    switch (key) {
      case 'today':
        vm.startDate = moment().startOf('day').unix() + '000000'
        vm.endDate = moment().endOf('day').unix() + '000000'
        vm.displayStartDate = moment().startOf('day').unix() + '000'
        vm.displayEndDate = moment().endOf('day').unix() + '000'
        break
      case '7days':
        vm.startDate = moment().subtract(7, 'days').startOf('day').unix() + '000000'
        vm.endDate = moment().endOf('day').unix() + '000000'
        vm.displayStartDate = moment().subtract(7, 'days').startOf('day').unix() + '000'
        vm.displayEndDate = moment().endOf('day').unix() + '000'
        break
      case '15days':
        vm.startDate = moment().subtract(15, 'days').startOf('day').unix() + '000000'
        vm.endDate = moment().endOf('day').unix() + '000000'
        vm.displayStartDate = moment().subtract(15, 'days').startOf('day').unix() + '000'
        vm.displayEndDate = moment().endOf('day').unix() + '000'
        break
      case '30days':
        vm.startDate = moment().subtract(30, 'days').startOf('day').unix() + '000000'
        vm.endDate = moment().endOf('day').unix() + '000000'
        vm.displayStartDate = moment().subtract(30, 'days').startOf('day').unix() + '000'
        vm.displayEndDate = moment().endOf('day').unix() + '000'
        break
      case '90days':
        vm.startDate = moment().subtract(90, 'days').startOf('day').unix() + '000000'
        vm.endDate = moment().endOf('day').unix() + '000000'
        vm.displayStartDate = moment().subtract(90, 'days').startOf('day').unix() + '000'
        vm.displayEndDate = moment().endOf('day').unix() + '000'
        break
      case '180days':
        vm.startDate = moment().subtract(180, 'days').startOf('day').unix() + '000000'
        vm.endDate = moment().endOf('day').unix() + '000000'
        vm.displayStartDate = moment().subtract(180, 'days').startOf('day').unix() + '000'
        vm.displayEndDate = moment().endOf('day').unix() + '000'
        break
      case '365days':
        vm.startDate = moment().subtract(365, 'days').startOf('day').unix() + '000000'
        vm.endDate = moment().endOf('day').unix() + '000000'
        vm.displayStartDate = moment().subtract(365, 'days').startOf('day').unix() + '000'
        vm.displayEndDate = moment().endOf('day').unix() + '000'
        break
      default:
        vm.startDate = moment().startOf('day').unix() + '000000'
        vm.endDate = moment().endOf('day').unix() + '000000'
        vm.displayStartDate = moment().startOf('day').unix() + '000'
        vm.displayEndDate = moment().endOf('day').unix() + '000'
        break
    }
  }

  vm.selectCustomDate = function () {
    vm.customDate = !vm.customDate
    vm.startDate = null
    vm.endDate = null
    vm.displayStartDate = null
    vm.displayEndDate = null
  }

  vm.load = function () {
    if (vm.customDate) {
      if (!vm.date1 || !vm.date2) {
        swal('Must choose dates', '', 'error')
        return
      }

      vm.startDate = moment(vm.date1).unix() + '000000'
      vm.displayStartDate = moment(vm.date1).unix() + '000'
      vm.endDate = moment(vm.date2).unix() + '000000'
      vm.displayEndDate = moment(vm.date2).unix() + '000'
    }

    vm.items = []

    var type = !vm.type ? '' : vm.type
    var userId = !vm.userId ? '' : vm.userId

    ShinieRedemptionService.list(vm.startDate, vm.endDate, userId, type).then(function (result) {
      vm.items = result.results
    })
  }

  vm.load()

  vm.clear = function () {
    vm.displayStartDate = moment().startOf('day').unix() + '000'
    vm.displayEndDate = moment().startOf('day').unix() + '000'
    vm.startDate = moment().startOf('day').unix() + '000000'
    vm.endDate = moment().endOf('day').unix() + '000000'
    vm.type = null
    vm.userId = null
    vm.date1 = null
    vm.date2 = null
    vm.customDate = false
  }
}
